import { Columns } from '@shared/interfaces/table/column-config';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';

/**
 * QuantityQuality Partial Translation Cell
 * Translates quantityQuality enum into relevant strings
 */
export const quantityQualityPartial: Columns<any> = {
  title: 'settlement.metered.view.quantityquality',
  key: 'quantityQuality',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    'notspecified': 'enum.quantityquality.notspecified',
    'estimated': 'enum.quantityquality.estimated',
    'asread': 'enum.quantityquality.asread',
    'revised': 'enum.quantityquality.revised',
    'calculated': 'enum.quantityquality.calculated',
    'missing': 'enum.quantityquality.missing',
    'incomplete': 'enum.quantityquality.incomplete',
  }
}
